import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
  style?: object;
};
function CheckTickMedium({
  size = 16,
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={style}><path fillRule="evenodd" clipRule="evenodd" d="M22 6.054L10.799 19.5 2.5 12.86l1.66-1.913 6.265 5.012L19.977 4.5 22 6.054z"  /></Svg>;
}
export default CheckTickMedium;